import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "post" };
const _hoisted_2 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center", "margin-bottom": "18px" } };
import { ref } from "vue";
import imgUpload from "@/components/Upload.vue";
import { ElMessage } from "element-plus";
import { Close, Plus } from "@element-plus/icons-vue";
import { getCaseList, saveCase, updateCase, deleteCase, } from "@/api/cases";
export default /*@__PURE__*/ _defineComponent({
    __name: 'post',
    emits: ["saved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const dialogVisible = ref(false);
        const title = ref("修改案例信息");
        const list = ref([]);
        const show = async () => {
            try {
                const res = await getCaseList();
                const data = res.data;
                list.value = data.map((c) => ({
                    id: c.id,
                    companyName: c.companyName || "",
                    content: c.content || "",
                    imgUrl: (() => {
                        try {
                            return JSON.parse(c.images || "[]");
                        }
                        catch {
                            return [];
                        }
                    })(),
                    imgIds: [],
                }));
                if (list.value.length === 0) {
                    list.value.push({ companyName: "", content: "", imgUrl: [], imgIds: [] });
                }
            }
            catch {
                list.value = [{ companyName: "", content: "", imgUrl: [], imgIds: [] }];
            }
            dialogVisible.value = true;
        };
        const onUpload = (index, val) => {
            list.value[index].imgUrl = val.pictureUrls;
            list.value[index].imgIds = val.pictureIds;
        };
        const handleAdd = () => {
            list.value.push({ companyName: "", content: "", imgUrl: [], imgIds: [] });
        };
        const handleDelete = async (index) => {
            if (list.value.length === 1) {
                ElMessage.error("至少保留一个案例");
                return;
            }
            const item = list.value[index];
            if (item.id) {
                try {
                    await deleteCase(item.id);
                }
                catch {
                    /* ignore */
                }
            }
            list.value.splice(index, 1);
        };
        const handleConfirm = async () => {
            try {
                for (const item of list.value) {
                    const payload = {
                        companyName: item.companyName,
                        content: item.content,
                        images: JSON.stringify(item.imgUrl),
                    };
                    if (item.id) {
                        await updateCase(item.id, payload);
                    }
                    else {
                        await saveCase(payload);
                    }
                }
                ElMessage.success("保存成功");
                dialogVisible.value = false;
                emit("saved");
            }
            catch {
                ElMessage.error("保存失败");
            }
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_col = _resolveComponent("el-col");
            const _component_el_row = _resolveComponent("el-row");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dialogVisible).value = $event)),
                    title: title.value,
                    "close-on-click-modal": false,
                    center: "",
                    style: { "width": "60%" }
                }, {
                    footer: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            onClick: _cache[0] || (_cache[0] = ($event) => (dialogVisible.value = false))
                        }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createTextVNode("取消", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleConfirm
                        }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("确认", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            "label-width": "auto",
                            size: "default"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_col, {
                                                span: 12,
                                                key: index
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_2, [
                                                        _createElementVNode("div", null, "案例" + _toDisplayString(index + 1), 1),
                                                        _createVNode(_component_el_icon, {
                                                            style: { "cursor": "pointer" },
                                                            size: "24",
                                                            onClick: ($event) => (handleDelete(index))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_unref(Close))
                                                            ]),
                                                            _: 1
                                                        }, 8, ["onClick"])
                                                    ]),
                                                    _createVNode(_component_el_form_item, { label: "布行名称：" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_el_input, {
                                                                modelValue: item.companyName,
                                                                "onUpdate:modelValue": ($event) => ((item.companyName) = $event),
                                                                placeholder: "请填写布行名称"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_el_form_item, { label: "布行logo：" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(imgUpload, {
                                                                imgUrl: item.imgUrl,
                                                                imgIds: item.imgIds,
                                                                width: 185,
                                                                height: 80,
                                                                onUploader: (v) => onUpload(index, v)
                                                            }, null, 8, ["imgUrl", "imgIds", "onUploader"])
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1024));
                                        }), 128))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleAdd
                        }, {
                            default: _withCtx(() => [
                                _cache[2] || (_cache[2] = _createTextVNode("添加案例", -1)),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Plus))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ]));
        };
    }
});
